module.exports = __webpack_public_path__ + "img/Wix_HW.f3927415.jpg";